import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom';

function ShowTables({ check }) {
    const [tables, setTables] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const [userPermissions, setUserPermissions] = useState([]);
    const [rerender, setRerender] = useState(false);

    // required functions during render
    const fetchTables = async () => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_BACKLINK}/api/private/get-tables`,
                { withCredentials: true }
            );
            const { data: packet } = await axios.get(
                `${process.env.REACT_APP_BACKLINK}/api/private/show-users`,
                { withCredentials: true }
            );
            // console.log(data.tables)
            setTables(data.tables)
            setUserPermissions(packet.permissions);
            setLoading(false)
        } catch (error) {
            setError(error.message);
        }
    }

    useEffect(() => {
        fetchTables();
    }, [rerender]);

    const dropTable = async (id) => {
        try {
            await axios.delete(
                `${process.env.REACT_APP_BACKLINK}/api/private/drop-table/${id}`
                ,
                { withCredentials: true }
            );
            setTimeout(() => {
                setMessage('')
            }, 5000)
            setMessage('Successfully Deleted')
            setRerender(!rerender);
        } catch (error) {
            setError(error.response.msg)
        }
    }

    return (
        <>
            {loading && <h1>Loading...</h1>}
            {error && <h1>{error}</h1>}
            {!check ? <h1>You do not have permission for this action, Contact with your admin</h1>
                :
                <div>
                    {message}
                    <Link to={'/create-table'} className="btn btn-success float-right">Add Table</Link>
                    <div className="card-body table-responsive p-0">
                        <table className="table text-nowrap">
                            <thead>

                                <tr>
                                    <th>#</th>
                                    <th>Tablename</th>
                                    <th>Columns</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tables.map((table, index) => (

                                    <tr key={table.id}>
                                        <td>{index + 1}</td>
                                        <td>{table.tablename}</td>
                                        <td>
                                            {table.tableColumns.map(column => (
                                                <p key={column}>{column}</p>
                                            ))}
                                        </td>
                                        <td>
                                            {userPermissions.includes('/drop-table/:id') && (
                                                <button
                                                    onClick={() => dropTable(table.id)}
                                                    className='btn btn-danger'
                                                >
                                                    Delete
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>
                </div>
            }
        </>
    )
}

export default ShowTables
